import { Link } from "react-router-dom";
import { Phone, Mail } from "lucide-react";
import { NAV_LINKS, PHONE_DISPLAY, PHONE_TEL, EMAIL, EMAIL_MAILTO } from "../data/content";

export const Footer = () => (
  <footer className="border-t border-ink/10 bg-white">
    <div className="mx-auto flex max-w-6xl flex-col gap-8 px-5 py-12 sm:px-8 md:flex-row md:items-start md:justify-between">
      <div>
        <div className="flex items-center gap-2.5">
          <img
            src="/images/logo.png"
            alt="Easyskip logo"
            className="h-8 w-8 object-contain"
          />
          <p className="font-heading text-xl font-extrabold tracking-tight text-ink">Easyskip</p>
        </div>
        <p className="mt-1 text-sm text-ink/55">
          Skip hire for Dublin &amp; Kildare. Licensed and fully insured.
        </p>
      </div>
      <nav className="flex flex-wrap gap-x-8 gap-y-3 text-sm">
        {NAV_LINKS.map((l) => (
          <Link
            key={l.to}
            to={l.to}
            data-testid={`footer-link-${l.label.toLowerCase()}`}
            className="font-medium text-ink/65 transition-colors duration-200 hover:text-ink"
          >
            {l.label}
          </Link>
        ))}
        <a
          href={PHONE_TEL}
          data-testid="footer-phone-link"
          className="flex items-center gap-1.5 font-medium text-ink/65 transition-colors duration-200 hover:text-ink"
        >
          <Phone className="h-3.5 w-3.5" />
          {PHONE_DISPLAY}
        </a>
        <a
          href={EMAIL_MAILTO}
          data-testid="footer-email-link"
          className="flex items-center gap-1.5 font-medium text-ink/65 transition-colors duration-200 hover:text-ink"
        >
          <Mail className="h-3.5 w-3.5" />
          {EMAIL}
        </a>
      </nav>
    </div>
    <div className="border-t border-ink/10 py-5 text-center text-xs text-ink/45">
      © {new Date().getFullYear()} Easyskip. All rights reserved. Prices include VAT.
    </div>
  </footer>
);
